var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "confirm-modal-block" }, [
      _c("div", { staticClass: "confirm-modal-header-block" }, [
        _c("p", { staticClass: "confirm-modal-header" }, [
          _vm._v("\n        " + _vm._s(_vm.header) + "\n      ")
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "confirm-modal-subheader",
            class: _vm.hidePopup ? "mb-1" : ""
          },
          [_vm._v("\n        " + _vm._s(_vm.subheader) + "\n      ")]
        )
      ]),
      _vm._v(" "),
      _vm.hidePopup
        ? _c("div", { staticClass: "custom-control" }, [
            _c("input", {
              staticClass: "custom-control-input",
              attrs: { type: "checkbox", id: "popup-hide" },
              on: { click: _vm.hidePopupMessage }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "custom-control-label font-16",
                staticStyle: { "padding-top": "7px" },
                attrs: { for: "popup-hide" }
              },
              [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm.$resourceString["virtualtray.confirm.modal.hide.msg"]
                    ) +
                    "\n            "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "confirm-modal-go-back-button",
          on: { click: _vm.handleGoBackClick }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$resourceString["virtualtray.confirm.modal.no.button"]
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "confirm-modal-continue-button",
          on: { click: _vm.onConfirm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$resourceString["virtualtray.confirm.modal.yes.button"]
              ) +
              "\n    "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "confirm-modal-close-button wf-modal-button-close btn button-full",
        attrs: { type: "button" },
        on: { click: _vm.handleGoBackClick }
      },
      [
        _c("span", {
          staticClass:
            "\n        confirm-modal-close-label\n        png-icon\n        png-icon-icons-symbols--k-txtclose\n      ",
          attrs: { "aria-label": "Close modal" }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }